export function matchConfidenceLabel(band, score) {
    return `How closely this matches: ${band} (${score.toFixed(2)})`;
}
export function stanceLabel(stance) {
    switch (stance) {
        case "endorsement":
            return "This page presents this idea as established.";
        case "criticism_or_rejection":
            return "This page questions or argues against this idea.";
        case "neutral_mention":
            return "This page mentions this idea.";
        case "questioning_or_uncertain":
            return "This page raises this idea as a question.";
        case "irrelevant":
            return "This passage may not really be about this idea.";
    }
}
/**
 * Awareness, not verdicts: these describe where the research currently stands,
 * in plain language, without calling an idea "false" or a page "wrong".
 */
export function evidenceStrengthLabel(strength) {
    switch (strength) {
        case "supported":
            return "Well supported by research";
        case "mixed_or_contested":
            return "Research is mixed";
        case "not_adequately_supported":
            return "Not well supported by research so far";
        case "insufficient_evidence":
            return "Too little research to say yet";
    }
}
export function evidenceStrengthTone(strength) {
    switch (strength) {
        case "supported":
            return "green";
        case "mixed_or_contested":
            return "amber";
        case "not_adequately_supported":
            return "red";
        case "insufficient_evidence":
            return "neutral";
    }
}
export function sourceVerificationTone(status) {
    switch (status) {
        case "verified":
            return "green";
        case "needs_review":
            return "amber";
        case "unverified":
            return "neutral";
    }
}
export function feedbackStatusTone(status) {
    switch (status) {
        case "actioned":
            return "green";
        case "triaged":
            return "neutral";
        case "dismissed":
            return "neutral";
        case "new":
            return "blue";
    }
}
